import {
    AgGridTable,
    type AgGridTableProps,
} from '@shared/components/ui/AgGridTable';
import type { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';
import { useAgGridColumns } from '../../hooks/useAgGridColumns';
import { OrderWithoutWeight } from '../../models/Order';

type SortingConfig = NonNullable<AgGridTableProps['sorting']>;

interface TableProps {
    orders: OrderWithoutWeight[];
    isLoading?: boolean;
    isFetching?: boolean;
    className?: string;
    fetchNextPage?: () => void;
    hasNextPage?: boolean;
    isFetchingNextPage?: boolean;
    sorting?: SortingConfig | null;
    onSortingChange?: (sorting: SortingConfig | null) => void;
    total?: number;
}

export const OrdersWithoutWeightAgGridTable = ({
    orders,
    isLoading = false,
    isFetching = false,
    className,
    fetchNextPage,
    hasNextPage = false,
    isFetchingNextPage = false,
    sorting,
    onSortingChange,
}: TableProps) => {
    const { allColumnDefs } = useAgGridColumns();
    const columnDefs = useMemo<ColDef<OrderWithoutWeight>[]>(
        () => allColumnDefs,
        [allColumnDefs]
    );

    return (
        <div
            className={`w-full transition-opacity duration-300 ${isFetching && !isFetchingNextPage
                    ? 'opacity-50 pointer-events-none'
                    : ''
                }`}
        >
            <AgGridTable
                data={orders}
                columnDefs={columnDefs}
                className={`rounded-lg shadow-sm ${className ?? ''}`.trim()}
                height="calc(100vh - 150px)"
                rowHeight={50}
                fetchNextPage={fetchNextPage}
                hasNextPage={hasNextPage}
                isFetchingNextPage={isFetchingNextPage}
                isLoading={isLoading}
                sorting={sorting}
                onSortingChange={onSortingChange}
                suppressCellFocus={true}
            />
        </div>
    );
};

